import { autoMount } from '../../../utils/autoMount';
import { OperatingCompanyHeader } from '../../../components/organisms/operatingCompanyHeader';

autoMount({ OperatingCompanyHeader });
